import React from 'react';
import { Box, Skeleton, Typography, Stack, IconButton, Grid, Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const VendorSkeleton = () => {
    const skeletonRows = Array.from({ length: 10 }); // Generate 10 skeleton rows for the list

    return (
        <Box
            mt={6}
        >
            <Box sx={{ padding: 2 }}>
                {/* Header Section */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Skeleton variant="rectangular" width={120} height={40} />
                    <Button variant="contained" color="success">
                        <Skeleton width={100} />
                    </Button>
                </Box>
                <Grid container spacing={2}>
                    {skeletonRows.map((_, index) => (
                        <Grid item xs={12} key={index}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: '#800020',
                                    padding: 2,
                                    borderRadius: 2,
                                }}
                            >
                                {/* Icon */}
                                <IconButton>
                                    <Skeleton variant="circular" width={40} height={40} />
                                </IconButton>

                                {/* Vendor Information */}
                                <Box sx={{ flexGrow: 1, marginLeft: 2 }}>
                                    <Skeleton width="40%" />
                                    <Skeleton width="60%" />
                                </Box>

                                {/* Icons (Phone, Social Media, etc.) */}
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                    <Skeleton variant="rectangular" width={24} height={24} />
                                </Stack>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default VendorSkeleton;